import { components } from "@zapier/api-clients/apis/templates-backend/types";
import { IconName } from "@zapier/zinnia-icons";

export const LOCALSTORAGE_TEMPLATE_CREATE_KEY = "createFromTemplateKey";

type ZSLAssetType = {
  name: keyof Pick<
    components["schemas"]["Template_zsl"],
    "interfaces" | "tables" | "chatbots" | "zaps" | "canvases"
  >;
  displayName: string;
  icon: IconName;
};

export const ZSL_ASSET_TYPES: ZSLAssetType[] = [
  {
    name: "zaps",
    displayName: "Zaps",
    icon: "miscBoltAltFill",
  },
  {
    name: "tables",
    displayName: "Tables",
    icon: "navTables",
  },
  {
    name: "interfaces",
    displayName: "Interfaces",
    icon: "navInterfaces",
  },
  {
    name: "chatbots",
    displayName: "Chatbots",
    icon: "navAIChatbot",
  },
  {
    name: "canvases",
    displayName: "Canvases",
    icon: "navCanvas",
  },
];
